// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/core.scss
// module id = 1386
// module chunks = 0